<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:goodsTitle="{ row }">
        <span>{{ $l('INDEX.form_label_SKU') || 'SKU' }}：</span
        ><span style="color: #409EFF">{{ row.sku }}</span>
        <br />
        <span>{{ $l('form_label_skuEcom') || '电商SKU' }}：</span
        ><span style="color: #409EFF">{{ row.sku_ecom }}</span>
        <br />
        <span>{{ $l('INDEX.form_label_fnskuCode') || 'FNSKU' }}：</span
        ><span style="color: #409EFF">{{ row.fnsku }}</span>
        <br />
        <span>{{ $l('INDEX.form_label_asinCode') || 'ASIN' }}：</span
        ><span style="color: #409EFF">{{ row.asin }}</span>
      </template>

      <template v-slot:originalFile="{ row }">
        <span
          >{{ $l('INDEX.table_label_originalFileName') || '文件名称' }}：</span
        ><span>{{ row.originalFileName }}</span>
        <br />
        <span>{{ $l('INDEX.table_label_uploadBy') || '上传人' }}：</span
        ><span>{{ row.createdByName }}</span>
        <br />
        <span>{{ $l('INDEX.table_label_uploadDate') || '上传时间' }}：</span
        ><span>{{ row.creationTime }}</span>
      </template>

      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="allow('M')"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'edit',
                code: row.recordCode,
              })
            "
          ></i>
        </el-tooltip>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {},
}
</script>
